import { SATIS_UI as S } from './metin/satis-ui';
import type { TaxChoice } from './quote-pricing';
import { VERGI_SECENEKLERI } from './vergi-secimi';

const ETIKET = { INCLUSIVE: S.taxChoiceInclusive, EXCLUSIVE: S.taxChoiceExclusive, NONE: S.taxChoiceNone } as const;

/**
 * Satır başına vergi seçimi: KDV dahil, üstüne ekle, vergi yok. Yalnız O satırı değiştirir. Teklifin varsayılanı
 * ayrı bölümde (açılır liste) durur, "Tüm satırlara uygula" düğmesi satırları ona çeker. `LEGACY` (eski, kalem bazlı
 * teklif) iken hiçbir düğme seçili görünmez; neden varsayılan bölümündeki notta yazılı.
 */
export function VergiSecici({ deger, sec, testId, className }: { deger: TaxChoice; sec: (kip: TaxChoice) => void; testId: string; className?: string }) {
  return (
    <div className={className ? `alan vergi-secici ${className}` : 'alan vergi-secici'}>
      <span className="vergi-secici-etiket" id={`${testId}-etiket`}>{S.taxChoiceLabel}</span>
      <div role="radiogroup" aria-labelledby={`${testId}-etiket`} data-testid={testId} data-value={deger} className="vergi-secici-dugmeler">
        {VERGI_SECENEKLERI.map((kip) => (
          <button key={kip} type="button" role="radio" aria-checked={deger === kip} data-testid={`${testId}-${kip}`}
            className={deger === kip ? 'vergi-secici-dugme secili' : 'vergi-secici-dugme'} onClick={() => sec(kip)}>
            {ETIKET[kip]}
          </button>
        ))}
      </div>
    </div>
  );
}
